"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextProductType = void 0;
var NextProductType;
(function (NextProductType) {
    NextProductType["UNKNOWN"] = "Unknown";
    NextProductType["KESB"] = "KESB";
    NextProductType["KHCS"] = "KHCS";
    NextProductType["KEDR"] = "KEDR";
    NextProductType["KNTIER1"] = "KNTier1";
    NextProductType["KNTIER2"] = "KNTier2";
    NextProductType["KNTIER3"] = "KNTier3";
    NextProductType["KNTIER0"] = "KNTier0";
    NextProductType["KNTIER3_5"] = "KNTier3_5";
    NextProductType["KNTIER4"] = "KNTier4";
    NextProductType["KNTIER4_U"] = "KNTier4_U";
})(NextProductType || (exports.NextProductType = NextProductType = {}));
